import _objectWithoutProperties from "/var/lib/jenkins/workspace/neo-insurance-webapp-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/var/lib/jenkins/workspace/neo-insurance-webapp-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/var/lib/jenkins/workspace/neo-insurance-webapp-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import * as r from "restructure";
import DACMarker from "./markers/dac.js";
import DefineHuffmanTableMarker from "./markers/dht.js";
import DQTMarker from "./markers/dqt.js";
import DRIMarker from "./markers/dri.js";
import EndOfImageMarker from "./markers/eoi.js";
import EXIFMarker from "./markers/exif.js";
import JFIFMarker from "./markers/jfif.js";
import SOSMarker from "./markers/sos.js";
import StartOfFrameMarker from "./markers/sof.js";
import StartOfImageMarker from "./markers/soi.js";
var UnkownMarker = {
  length: r.uint16be,
  buf: new r.Buffer(function (parent) {
    return parent.length - 2;
  })
};
var unknownMarkers = Array(63).fill(0).reduce(function (acc, v, i) {
  return _objectSpread({}, acc, _defineProperty({}, i + 0xffc0, UnkownMarker));
}, {});
var Marker = new r.VersionedStruct(r.uint16be, _objectSpread({}, unknownMarkers, {
  0xffc0: StartOfFrameMarker,
  0xffc1: StartOfFrameMarker,
  0xffc2: StartOfFrameMarker,
  0xffc3: StartOfFrameMarker,
  0xffc4: DefineHuffmanTableMarker,
  0xffc5: StartOfFrameMarker,
  0xffc6: StartOfFrameMarker,
  0xffc7: StartOfFrameMarker,
  0xffc9: StartOfFrameMarker,
  0xffca: StartOfFrameMarker,
  0xffcb: StartOfFrameMarker,
  0xffcc: DACMarker,
  0xffcd: StartOfFrameMarker,
  0xffce: StartOfFrameMarker,
  0xffcf: StartOfFrameMarker,
  0xffd8: StartOfImageMarker,
  0xffd9: EndOfImageMarker,
  0xffda: SOSMarker,
  0xffdb: DQTMarker,
  0xffdd: DRIMarker,
  0xffe0: JFIFMarker,
  0xffe1: EXIFMarker
}));
var JPEG = new r.Array(Marker);
var decode = function decode(buffer) {
  var markers = JPEG.fromBuffer(buffer);
  return markers.map(function (_ref) {
    var version = _ref.version,
      rest = _objectWithoutProperties(_ref, ["version"]);
    return _objectSpread({
      type: version
    }, rest);
  });
};
export default {
  decode: decode
};